<div class="list-container">
  <ng-container *ngFor="let item of items; let last = last">
    <div
      class="list-item"
      [class.disabled]="item.disabled"
      [class.active]="isItemActive(item)"
      [style.padding]="padding"
      [style.font-size]="fontSize"
      [style.font-weight]="fontWeight"
      [style.color]="isItemActive(item) ? activeTextColor : textColor"
      (click)="onItemClick(item)"
    >
      <div class="left-icon" *ngIf="item.leftIcon">
        <i [class]="item.leftIcon" [style.color]="iconColor"></i>
      </div>

      <div class="item-text">
        {{ item.text }}
      </div>

      <div class="right-icon" *ngIf="isItemActive(item)" [style.color]="iconColor">
        <i class="fas fa-chevron-right"></i>
      </div>
    </div>

    <div class="divider" *ngIf="!last && showDividers" [style.background-color]="dividerColor"></div>
  </ng-container>
</div>
